import { svgIcon } from "../icon-service";

export const BackgroundRightIllustration = svgIcon`
`;
